module.exports = __webpack_public_path__ + "img/43.79ac0360.jpg";